import { createAcpResource } from 'syft-acp-core/api/resource'

export const resSalesWinAssociations = createAcpResource('resSalesWinAssociations', {
  uri: [({ employerID }) => `/admin/sales/sales_win_associations/${employerID}`, 'GET', 'POST'],
  uriVars: ['employerID'],
  paginated: true,
})
